import React from 'react';
import { connect } from 'react-redux';

// Constellation Components
import {
    FormField,
    Input,
    Label,
    Spacer,
} from '@zillow/constellation';

// Styled Components
import {
    StyledActionsContainerSpacer,
    StyledIconCloseOutline,
    StyledIconReload,
    StyledImgInfoDiv,
    StyledText,
    StyledUploadedImgDiv,
} from './StyledComponents';

const PhotoDisplay = ({
    photo,
    hideCaption,
    inputBlur,
    inputChange,
    inputValue,
    rotatePhoto,
    removePhoto,
}) => {
    if (photo.url) {
        photo.url = photo.url.replace('http://photo', 'https://photonet');
    }

    return (
        <Spacer paddingY="sm" className="PhotoDisplay">
            <StyledUploadedImgDiv>
                <img alt="carousel-img" src={photo.url ? photo.url : photo.preview} />
            </StyledUploadedImgDiv>
            <StyledImgInfoDiv>
                {!hideCaption ? (
                    <Spacer paddingY="xs">
                        <FormField>
                            <Label>Caption</Label>
                            <Input
                                onBlur={inputBlur}
                                onChange={inputChange}
                                name="caption"
                                placeholder="Describe this photo"
                                value={inputValue}
                                data-test="photo-display-caption"
                            />
                        </FormField>

                        <StyledActionsContainerSpacer marginTop="xs">
                            <div onClick={rotatePhoto}>
                                <StyledText>
                                    <StyledIconReload />
                                    Rotate photo
                                </StyledText>
                            </div>

                            <div onClick={removePhoto}>
                                <StyledText>
                                    <StyledIconCloseOutline />
                                    Delete photo
                                </StyledText>
                            </div>
                        </StyledActionsContainerSpacer>
                    </Spacer>
                ) : (
                    null
                )}
            </StyledImgInfoDiv>
        </Spacer>
    );
};

export { PhotoDisplay };
export default connect()(PhotoDisplay);
